import { ToastType } from '../../../components/toast/types';
import type { GameCommunicationToasterType } from '../../../services/gameCommunication/types';
import { toastActions } from '../../../store/slices/toast/slice';
import automatedMessageToasterMapping from '../automatedMessageToasterMapping.json';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

export class CoreAutomatedMessagesGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.ToasterMessage;

  public process(message: GameCommunicationToasterType): void {
    const state = this.store.getState();
    if (state.config?.tableConfig?.isAutomatedMessagesEnabled) {
      const toasterKey = (automatedMessageToasterMapping as Record<string, string>)[message.code];
      if (!toasterKey) {
        console.error(`No toaster mapping found for automated message: ${message.code}`);
        return;
      }
      this.store.dispatch(
        toastActions.createDynamicToast({ message: toasterKey, toasterType: ToastType.TOAST_AUTOMATED_MESSAGE })
      );
    }
  }
}
